import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { OrnamentDivider } from "./Ornaments";
import { POLICIES } from "@/lib/policies";
import { api } from "@/lib/api";
import "./PolicyPage.css";

const CONTENT_KEY_MAP = {
  terms: "terms",
  privacy: "privacy",
  safety: "safety",
  payment: "payment",
  matchFee: "match_fee",
  faq: "faq",
  about: "about",
};

const FALLBACK_TITLES = {
  faq: { title: "Frequently Asked Questions", subtitle: "Common questions about Suffa Matrimony." },
  about: { title: "About Suffa Matrimony", subtitle: "A trusted Muslim matrimonial service — for serious and halal rishtas." },
};

const PolicyPage = ({ policyKey }) => {
  const staticPolicy = POLICIES[policyKey];
  const [override, setOverride] = useState(undefined); // undefined = loading, null = none

  useEffect(() => {
    document.title = `${staticPolicy?.title || FALLBACK_TITLES[policyKey]?.title || "Suffa Matrimony"} | Suffa Matrimony`;
  }, [staticPolicy, policyKey]);

  useEffect(() => {
    api
      .get(`/content/${CONTENT_KEY_MAP[policyKey]}`)
      .then((d) => setOverride(d.content))
      .catch(() => setOverride(null));
  }, [policyKey]);

  const fallback = staticPolicy || FALLBACK_TITLES[policyKey];
  const title = override?.title || fallback?.title || "Suffa Matrimony";
  const subtitle = staticPolicy?.subtitle || fallback?.subtitle || "";

  return (
    <div className="suffa-page">
      <SiteHeader />
      <main className="policy-main">
        <section className="policy-masthead">
          <div className="policy-container policy-masthead-inner">
            <OrnamentDivider />
            <h1 className="policy-title" data-testid="policy-title">
              {title}
            </h1>
            {subtitle && <p className="policy-subtitle" data-testid="policy-subtitle">{subtitle}</p>}
          </div>
        </section>

        <div className="policy-container">
          <div className="policy-card" data-testid="policy-content">
            {override ? (
              override.body
                .split(/\n{2,}|\r\n\r\n/)
                .filter((p) => p.trim())
                .map((p, i) => (
                  <p className="policy-text" style={{ whiteSpace: "pre-line" }} key={i}>
                    {p}
                  </p>
                ))
            ) : staticPolicy ? (
              staticPolicy.sections.map((s) => (
                <section className="policy-section" key={s.heading}>
                  <h3 className="policy-section-title">{s.heading}</h3>
                  {s.body?.map((p, i) => (
                    <p className="policy-text" key={i}>
                      {p}
                    </p>
                  ))}
                  {s.list && (
                    <ul className="policy-list">
                      {s.list.map((li, i) => (
                        <li key={i}>{li}</li>
                      ))}
                    </ul>
                  )}
                  {s.after?.map((p, i) => (
                    <p className="policy-text" key={`a-${i}`}>
                      {p}
                    </p>
                  ))}
                </section>
              ))
            ) : (
              <p className="policy-text">
                This page is being prepared by the Suffa Matrimony team. Please contact us for any
                information in the meantime, insha’Allah.
              </p>
            )}
          </div>

          <div className="policy-back">
            <Link
              to="/"
              className="btn btn-outline btn-lg policy-back-btn"
              data-testid="policy-back-home"
            >
              <ArrowLeft size={16} aria-hidden="true" />
              Back to Home
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PolicyPage;
